// -----------------  UPDATE PIN NUMBER -----------------
export const UPDATE_PIN_NUMBER_LOADING = 'UPDATE_PIN_NUMBER_LOADING';
export const UPDATE_PIN_NUMBER_SUCCESS = 'UPDATE_PIN_NUMBER_SUCCESS';
export const UPDATE_PIN_NUMBER_ERROR = 'UPDATE_PIN_NUMBER_ERROR';

// -----------------  CLEAR PIN DATA -----------------
export const UPDATE_PIN_CLEAR_PIN_DATA = 'UPDATE_PIN_CLEAR_PIN_DATA';
